import { render, staticRenderFns } from "./supermarket.vue?vue&type=template&id=7edb800a&"
import script from "./supermarket.vue?vue&type=script&lang=js&"
export * from "./supermarket.vue?vue&type=script&lang=js&"
import style0 from "./supermarket.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports